module.exports = __webpack_public_path__ + "static/media/logo_reports_azul.76f78248.png";